import React, { useState } from "react";
import {
    Layout,
    Breadcrumb,
    Button,
    Row,
    Spin,
    Card,
    Col,
    DatePicker,
    message,
} from "antd";
import { Line } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    LineElement,
    CategoryScale,
    LinearScale,
    PointElement,
    Tooltip,
    Legend,
} from 'chart.js';
import axios from "axios";
import dayjs from "dayjs";
import { APPBACKGROUND_COLOR, MAINAPIURL } from "../../appsettings";
import { AlertError } from "../../usableclasses";
import Headerdiv from "../../layout/header";
import Footerdiv from "../../layout/footer";
import { Link } from "react-router-dom";
import { SearchOutlined } from "@ant-design/icons";

const { Content } = Layout;
const { RangePicker } = DatePicker;

ChartJS.register(LineElement, CategoryScale, LinearScale, PointElement, Tooltip, Legend);

const DailySaleReportChart = () => {
    const ApiURL = MAINAPIURL;
    const TOKEN = localStorage.getItem("AUTHCODE");
    const [isLoading, setIsLoading] = useState(false);
    const [saleItems, setSaleItems] = useState([]);
    const [dateRange, setDateRange] = useState([]);

    const chartData = {
        labels: saleItems.map((item) => dayjs(item.orderDate).format('YYYY-MM-DD')),
        datasets: [
            {
                label: 'BV Total',
                data: saleItems.map((item) => item.bvTotal),
                fill: false,
                borderColor: 'rgba(75, 192, 192, 1)',
                tension: 0.3,
            },
            {
                label: 'CP Total',
                data: saleItems.map((item) => item.cpTotal),
                fill: false,
                borderColor: 'rgba(153, 102, 255, 1)',
                tension: 0.3,
            },
            {
                label: 'Order Total',
                data: saleItems.map((item) => item.orderTotal),
                fill: false,
                borderColor: 'rgba(255, 159, 64, 1)',
                tension: 0.3,
            },
            {
                label: 'Product Total',
                data: saleItems.map((item) => item.productTotal ?? 0),
                fill: false,
                borderColor: 'rgba(255, 99, 132, 1)',
                borderWidth: 3,
                tension: 0.3,
            },
            {
                label: 'Handling Fee Total',
                data: saleItems.map((item) => item.handlingFeeTotal),
                fill: false,
                borderColor: 'rgba(54, 162, 235, 1)',
                tension: 0.3,
            },
            {
                 label: 'Shipping Fee Total',
                data: saleItems.map((item) => item.shippingTotal),
                fill: false,
                borderColor: 'rgba(75, 192, 192, 1)',
                tension: 0.3,  
            }
        ],
    };

    const chartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: { position: 'top' },
            tooltip: { mode: 'index', intersect: false },
        },
        scales: {
            y: {
                beginAtZero: true,
            },
        },
    };



    const fetchSaleItems = async () => {
        if (!dateRange || dateRange.length !== 2) {
            message.warning("Please select a date range first.");
            return;
        }

        try {
            setIsLoading(true);
            const headers = { SystemAccessToken: TOKEN };
            const payload = {
                startDate: dayjs(dateRange[0]).format("YYYY-MM-DD"),
                endDate: dayjs(dateRange[1]).format("YYYY-MM-DD"),
            };

            const response = await axios.post(
                `${ApiURL}/reports/sales/dailysalessummarybydaterange`,
                payload,
                { headers }
            );
            setSaleItems(response.data);
        } catch (error) {
            AlertError("Failed to Load Sale Report Items");
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Spin spinning={isLoading} tip="Processing...">
            <Layout style={{ backgroundColor: APPBACKGROUND_COLOR }}>
                <Headerdiv />
                <Content style={{ padding: "10px" }}>
                    <Breadcrumb style={{ margin: "16px 0" }}>
                        <Breadcrumb.Item><Link to={"/reports"}>Reports</Link></Breadcrumb.Item>
                        <Breadcrumb.Item>Daily Sale Chart Report</Breadcrumb.Item>
                    </Breadcrumb>

                    <Card title="Filters" style={{ marginBottom: 20 }}>
                        <Row gutter={16} justify="flex-start" align="middle" style={{ marginBottom: 16 }}>
                            <Col>
                                <RangePicker
                                    format="YYYY-MM-DD"
                                    onChange={(dates) => setDateRange(dates)}
                                />
                            </Col>
                            <Col>
                                <Button icon={<SearchOutlined/>} type="primary" onClick={fetchSaleItems} loading={isLoading}>
                                    Get Data
                                </Button>
                            </Col>
                        </Row>
                    </Card>

                    <Card title="Daily Sales Summary Report Chart" style={{ marginBottom: 20 }}>
                        {saleItems.length > 0 ? (
                            <div style={{ position: 'relative', width: '100%', height: '400px' }}>
                                <Line data={chartData} options={chartOptions} />
                            </div>
                        ) : (
                            <p>No data to display. Please select a date range and click "Get Data".</p>
                        )}
                    </Card>


                </Content>
                <Footerdiv />
            </Layout>
        </Spin>
    );
};

export default DailySaleReportChart;
